const VIDEO_ID = "5GdmzYPV4Kc";

export const TOUR_EMBED_URL = `https://www.youtube-nocookie.com/embed/${VIDEO_ID}`;
export const TOUR_WATCH_URL = `https://www.youtube.com/watch?v=${VIDEO_ID}`;
